import React from 'react';
import IEFallbackWrapper from 'components/IEFallbackWrapper';
import { shallowEqual, useSelector } from 'react-redux';
import CircularLoadingIndicator from 'components/indicators/CircularLoadingIndicator';
import LazyBoothList from './LazyBoothList';
import IEBoothList from './IEBoothList';

export interface HallListComponentProps {
  exhibitorIds: string[];
  exhibitorIdsGroupedByTierIds: { [key: string]: Array<string> };
  isFiltered: boolean;
  hasFilter: boolean;
}

const HallListComponent = (props: HallListComponentProps) => {
  const isFetchingBooths = useSelector((state) => (state as any).cms.booths.fetching, shallowEqual);

  if (isFetchingBooths) {
    return <CircularLoadingIndicator />;
  }

  return (
    <IEFallbackWrapper
      fallback={<IEBoothList {...props} />}
    >
      <LazyBoothList {...props} />
    </IEFallbackWrapper>
  );
};

export default HallListComponent;
